import { render, staticRenderFns } from "./ClientThemes.vue?vue&type=template&id=2b275aee&"
import script from "./ClientThemes.vue?vue&type=script&lang=js&"
export * from "./ClientThemes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports